import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type IntegrationStatus as SchemaIntegrationStatus } from '../schemas/IntegrationStatus';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const SyncExternalStoreWarehousesContentType = '' as const;
export type SyncExternalStoreWarehousesRequest = void;
export type SyncExternalStoreWarehousesResponses = LinkCommonErrorResponses & {
    /**
     * @description Synchronization successfully initiated
     */
    '200': {
        'application/json': SchemaIntegrationStatus;
    };
};
export type SyncExternalStoreWarehousesResponseSuccess =
    SyncExternalStoreWarehousesResponses['200']['application/json'];
export type SyncExternalStoreWarehousesSearchParams = undefined;
export type SyncExternalStoreWarehousesPathParameters = undefined;
export const SyncExternalStoreWarehousesUrl = '/integrations/external_store/warehouses' as const;
export const SyncExternalStoreWarehousesMethod = 'POST' as const;
export const getSyncExternalStoreWarehousesUrl = (_params?: SyncExternalStoreWarehousesPathParameters) =>
    SyncExternalStoreWarehousesUrl;
